export const iconFontAwesomeDesignCrop = (
	<i className="fa-solid fa-crop"></i>
);
